import { IMenu } from '@/typings';
import { createContext, useContext } from 'react';
import { NavigateFunction } from 'react-router-dom';

export interface AuthContextType {
	// freeUser: string;
	generateFinger: () => void;
	isAuth: () => boolean;
	signOut: (navigate?: NavigateFunction) => void;
	autoSignOut: (navigate?: NavigateFunction) => void;
	routes: IMenu[];
}

export const AuthContext = createContext<AuthContextType | null>(null);

export const useAuth = () => useContext(AuthContext);
